// no itx for this file
import BaseModel from "../models/BaseModel";

import TreeViewModel, { DragMode, DropResult } from "../models/TreeviewModel";

import Logger from "../Logger";
import type Fuse from "../models/Fuse";
import type Consumer from "../models/Consumer";
import type Room from "../models/Room";
import type Channel from "../models/Channel";
import type Actor from "../models/Actor";
import FuseConsumerReference from "../models/FuseConsumerReference";
import BaseModelReference from "../models/BaseModelReference";
import Terminal from "../models/Terminal";
import FusePlacementDialog from "../components/dialogs/FusePlacementDialog";

const logger = new Logger();

export default class FuseTreeViewModel extends TreeViewModel {
  get typedObj(): Fuse {
    return this.obj as Fuse;
  }

  get isFolder(): boolean {
    return true;
  }

  getTagNeeded(): boolean {
    return true;
  }

  get childCollection(): Array<BaseModel> | undefined {
    const res = new Array<FuseConsumerReference>();
    this.typedObj.consumers.forEach((consumer) => {
      res.push(new FuseConsumerReference(this.typedObj, consumer));
    });

    return res;
  }

  get iconUrl(): string | undefined {
    if (this.typedObj) {
      if (this.typedObj.is_FI_LS) {
        return state.hostBaseUrl + "images/fuse/fi_ls.png";
      } else {
        return state.hostBaseUrl + "images/fuse/fuse.png";
      }
    }

    return undefined;
  }

  allowDrop(event: any): boolean {
    return true;
  }

  allowDrag(): boolean {
    return true;
  }

  async handleDrop2(mode: DragMode, obj: BaseModel): Promise<DropResult> {
    const fuse = this.typedObj as Fuse;

    if (obj == fuse) {
      return new DropResult(false);
    }

    switch (obj.className) {
      case "Actor": {
        let found = false;
        const actor = obj as Actor;
        actor.channels.forEach((channel) => {
          const consumer = channel.getConnectedConsumer();
          if (consumer) {
            found = consumer.connectWithFuse(fuse);
          }
        });

        if (found && fuse.name == "") {
          const name = `${actor.tag} ${actor.name}`.trim();
          fuse.name = name;
        }
        return new DropResult(found);
      }

      case "Channel": {
        const channel = obj as Channel;
        const consumer = channel.getConnectedConsumer();
        if (consumer) {
          return new DropResult(consumer.connectWithFuse(fuse));
        } else {
          return new DropResult(false);
        }
      }

      case "Consumer": {
        const consumer = obj as Consumer;

        return new DropResult(consumer.connectWithFuse(fuse));
      }

      case "Room": {
        const room = obj as Room;
        let done = room.conectAll230ConsumersWihFuse(fuse);

        let name = "";
        if (room.cabinet && room.cabinet == fuse.parent?.parent) {
          name = `${room.getRelativeTag(room.cabinet)} ${room.name}`.trim();
        } else {
          name = `${room.fullTag} ${room.name}`.trim();
        }

        fuse.name = fuse.name + " " + name;

        fuse.raiseOnChange();
        return new DropResult(done);
      }
      case "Fuse": {
        const fuse2 = obj as Fuse;
        // place fuse to other place?
        await state.dialogManager.openDialog(<FusePlacementDialog fuse={fuse2} targetFuse={fuse} />);
        return new DropResult(true);
        //return (fuse.parent as ELCB).treeViewModel.handleDrop2(mode, fuse);
      }
      case "Terminal": {
        const terminal = obj as Terminal;
        const consumer = terminal.consumer;
        if (consumer) {
          return new DropResult(consumer.connectWithFuse(fuse));
        } else {
          return new DropResult(false);
        }
      }
      case "FuseConsumerReference":
      case "BaseModelReference": {
        const ref = obj as BaseModelReference;
        const consumer = ref.referencedObject;
        if (
          consumer?.className == "Consumer" ||
          consumer?.className == "Actor" ||
          consumer?.className == "Channel" ||
          consumer?.className == "Room"
        ) {
          return this.handleDrop2(mode, consumer);
        }
      }
    }

    return new DropResult(false);
  }

  ////////////////////////////////////////////////////////////////////////////////////////
  //
  // inline menu buttons
  //super.inlineButton_Properties(),
  ////////////////////////////////////////////////////////////////////////////////////////

  getButtons(): JSX.Element[] | undefined {
    return [super.inlineButton_Open("homePane.openFuseSettings")];
  }

  ////////////////////////////////////////////////////////////////////////////////////////
  //
  // context menu
  //
  ////////////////////////////////////////////////////////////////////////////////////////

  get contextMenuItems(): any {
    var subLabelPaste = undefined;

    try {
      subLabelPaste = state.contextMenuManager.clipboardData.items[0].name;
    } catch (ex) {
      logger.error(ex);
    }

    return {
      items: [this.baseContextMenuItems_Delete(), this.baseContextMenuItems_Open()],
    };
  }

  ////////////////////////////////////////////////////////////////////////////////////////
  canBePastedInteractive(copiedObjClassName: string): boolean {
    return false;
  }
  ////////////////////////////////////////////////////////////
}
